<template>
  <v-container>
    <v-layout>
      <v-flex md10 xs12 offset-md1>
        <v-card>
          <v-card-title>
            <v-btn
              color="error"
              :disabled="!Boolean(selectedTableItems.length)"
              @click="openDeleteDialog(selectedTableItems)"
            >
              <v-icon left>delete</v-icon>
              移除
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" :loading="loadingTokens" @click="init()">刷新</v-btn>
            <v-btn color="primary" class="ml-2" @click="batchDialog = true">
              <v-icon left>mdi-key-plus</v-icon>批量新增
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-alert v-if="syncError" type="warning" text>密钥列表暂时无法同步，请刷新重试。</v-alert>
            <v-data-table
              :no-data-text="
                $store.state.query.loading ? '加载中…' : $vuetify.noDataText
              "
              :headers="headers"
              :items="tokens"
              :footer-props="{ 'items-per-page-options': rowsPerPage }"
              show-select
              v-model="selectedTableItems"
              item-key="token"
            >
              <template #item.actions="{ item }">
                <v-menu>
                  <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openDeleteDialog([item])">
                      <v-list-item-title> 删除权限密钥 </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="copyToClipboard(item.token)">
                      <v-list-item-title> 复制密钥 </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template #item.tokenCreated="{ item }">
                {{ new Date(item.tokenCreated * 1000).toLocaleString() }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title> 删除权限密钥 </v-card-title>
          <v-card-text> 确定删除此权限密钥？ </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialog = false">否</v-btn>
            <v-btn text color="primary" @click="deleteToken">是</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <token-batch-add v-if="batchDialog" v-model="batchDialog" @tokens-created="init()" @refresh="init(true)"></token-batch-add>

      <v-btn
        fab
        color="primary"
        fixed
        bottom
        right
        dark
        :to="{ name: 'token-add' }"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: { TokenBatchAdd: () => import("@/components/TokenBatchAdd") },
  data() {
    return {
      dialog: false,
      tokens: [],
      headers: [
        { text: "", value: "actions", align: "start", sortable: false },
        { text: "权限密钥", value: "token" },
        { text: "类型", value: "tokenType" },
        { text: "身份组", value: "tokenId1" },
        { text: "频道", value: "tokenId2" },
        { text: "创建时间", value: "tokenCreated" },
        { text: "说明", value: "tokenDescription" },
      ],
      rowsPerPage: [25, 50, 75, -1],
      selectedTableItems: [],
      tokenRemoveList: [],
      batchDialog: false,
      loadingTokens: false,
      syncError: false,
      refreshTimer: undefined,
    };
  },
  methods: {
    getTokenList() {
      return this.$TeamSpeak.execute("tokenlist");
    },
    openDeleteDialog(tokens) {
      this.tokenRemoveList = tokens;

      this.dialog = true;
    },
    async deleteToken() {
      try {
        for (let token of this.tokenRemoveList) {
          await this.$TeamSpeak.execute("tokendelete", { token: token.token });
        }

        this.dialog = false;
      } catch (err) {
        this.$toast.error(err);
      }

      // v-model is not updating correctly when the content of the table changes.
      // Removed content is still in the selectedTableItems array.
      // This is a workaround for this vuetify bug.
      this.selectedTableItems = [];

      this.init();
    },
    copyToClipboard(token) {
      this.$clipboard(token);

      this.$toast.info("Token Copied To Clipboard");
    },
    refreshTokens() {
      if (!document.hidden) this.init(true);
    },
    async init(silent = false) {
      if (this.loadingTokens) return;
      this.loadingTokens = true;
      try {
        this.tokens = await this.getTokenList();
        this.syncError = false;
      } catch (err) {
        this.syncError = true;
        if (!silent) this.$toast.error(err);
      } finally {
        this.loadingTokens = false;
      }
    },
  },
  created() {
    this.init();
    this.$TeamSpeak.on("tokenused", this.refreshTokens);
    this.refreshTimer = setInterval(this.refreshTokens, 5000);
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer);
    this.$TeamSpeak.off("tokenused", this.refreshTokens);
  },
};
</script>
